// extracted by mini-css-extract-plugin
export default {"qrContainer":"qr-code_qrContainer__3amXU","hideCanvas":"qr-code_hideCanvas__J86LF","copyButton":"qr-code_copyButton__Qodxp"};